<template>

    <div class="my-logEnterprise-wrapper">
        <!-- 顶部轮播图 -->
        <div class="top-block">
            <hua-swipe class="my-swipe" :autoplay="3000" indicator-color="white" indicator-type="point">
                <hua-swipe-item v-for="item in imgList" :key="item.id">
                    <hua-image fit="fill" width="100%" height="100%" radius="10" :src="item.value"></hua-image>
                </hua-swipe-item>
            </hua-swipe>    
        </div>
        <div class="ad-box">
            <img class="ad-img" src="@/image/home_pic_ad.png" alt="">
            <!-- 为了绑定点击事件，放俩透明的盒子占位 -->
            <!-- 入校最新动态 -->
            <div class="btn btn-box1" @click="goAd(1)"></div>
            <!-- 车辆管理办法 -->
            <div class="btn btn-box2" @click="goAd(2)"></div>
        </div>
        <!-- 邀约申请 -->
        <img class="apply-img"
            src="@/image/home_pic_yysq.png"
            alt=""
            @click="toAppointment" >
        <!-- 审批管理 -->
        <div class="approve-box" @click="toPendApproval">
            <div class="num-box num1">{{approveStat['审批记录']}}</div>
            <div class="num-box num2">{{approveStat['待审批']}}</div>
            <div class="num-box num3">{{approveStat['今日新增']}}</div>
            <img src="@/image/home_pic_spgl.png" alt="">
        </div>
    </div>
</template>

<script>
import api from '@/constants/api'
import utils from "@/constants/utils";
import common from "@/view/common.js"
import image1 from '@/image/swip-img.png'
import image2 from '@/image/test2.jpeg'
import image3 from '@/image/test3.jpeg'
import logoImg from '@/image/logo.png'
import {aes_decrypt, getKey} from '@/tools/myEncrypt'
export default {
    data() {
        return {
            imgList:[
                {
                    id:1,
                    value: image1
                },
                {
                    id:2,
                    value: image2
                },
                {
                    id:3,
                    value: image3
                }
            ],
            logoImg,
            utils,
            userName: '',
            password: '',
            placeholder: '请输入',
            timer: null,
            personId: '',
            personName: '',
            wrapperHeight:0,
            personCode:"",
            approveStat: {
                '审批记录': 0,
                '待审批': 0,
                '今日新增': 0,
            }
        }
    },
    methods: {
        goAd(flag) {
            // flag === 1,动态，2车辆
            console.log('flag', flag);
            if(flag === 1) {
                window.location.href = 'https://mp.weixin.qq.com/s/IekdWBev2jOMVDw311wkyw'
            } else {
                window.location.href = 'https://mp.weixin.qq.com/s/bjshr0xMXK2cewvE-3Kldg'
            }
        },
        // 跳转到待审核页面
        toPendApproval () {
            localStorage.setItem('myVisitorListActive', 0);
            localStorage.setItem('pageName','approvalManage');
            this.$router.push(`/approvalManage/${this.personId}`);
        },
        // 跳转到邀约页面
        toAppointment () {
            localStorage.setItem('myVisitorListActive', 2);
            localStorage.setItem('pageName','teacherInvita');
            this.$router.push(`/teacherInvita/${this.personId}`)
        },
        // 根据手机号查询被访人
        async getInterviewee() {
            try {
                // 先获取密钥
                const keyInfo = await getKey()
                if (!keyInfo) {
                    this.$toast('获取密钥失败，请重试')
                    return
                }
                // 再获取业务数据（传入时间戳）
                let res1 = await api.getIntervieweeNameByCode(this.personCode, undefined, keyInfo.visitorstampKey);
                if(res1.data) {
                    // 最后解密
                    const descData = await aes_decrypt(res1.data, keyInfo)
                    if (!descData) {
                        this.$toast('解密失败，请重试')
                        return
                    }
                    res1.data = descData
                }
                if (res1.success) {
                    // 1学生2教职工
                    const visitorMode = res1.data.ermPersonType ? Number(res1.data.ermPersonType) : ''
                    localStorage.setItem('visitorMode', visitorMode)
                    const res = {
                        data: res1.data || {}
                    }
                    console.log('resresres3', res);
                    this.phone = res.data.phone
                    this.personId = res.data.id
                    this.personName = res.data.name
                }
            } catch (error) {
                console.log(error)
            }
            localStorage.setItem('u_phone', this.phone)
            localStorage.setItem('v_personid', this.personId)
            sessionStorage.setItem('u_name', this.personName)
        },
        // 获取今日审批数据
        async getApproveNum() {
            try {
                const res = await api.getApprovePersonNum(this.personCode)
                if(res.success) {
                    this.approveStat = {
                        '审批记录': res.data.reviewCount || 0,
                        '待审批': res.data.unReviewCount || 0,
                        '今日新增': res.data.todayVisitorCount || 0,
                    }
                } else {
                    this.approveStat = {
                        '审批记录': 0,
                        '待审批': 0,
                        '今日新增': 0,
                    }
                    this.$toast('获取审批统计数据失败！')
                }
            } catch(err) {
                this.approveStat = {
                    '审批记录': 0,
                    '待审批': 0,
                    '今日新增': 0,
                }
                console.log(err);
                this.$toast(err.errMsg || '获取审批统计数据失败！')
            }
        },
    },
    mounted() {
        // this.wrapperHeight = document.body.clientHeight - document.getElementById("nav-bar").offsetHeight - (document.body.clientHeight * 0.1);
        this.wrapperHeight = document.body.clientHeight;
        let curHref = window.location.href;
        let hrefParam = common.getUrlParams(curHref)
        // this.personId = hrefParam.personId
        // this.personName = decodeURI(hrefParam.personName)
        // this.phone = hrefParam.phone
        this.personCode = hrefParam.personCode
        if(this.personCode) {
            this.getInterviewee();
            this.getApproveNum() // 获取审批统计
            sessionStorage.setItem('u_jobNumber', this.personCode)
        } else {
            sessionStorage.setItem('u_jobNumber', '')
            localStorage.setItem('v_personid', '')
            sessionStorage.setItem('u_name', '')
            localStorage.setItem('u_phone', '')
        }
    }
}
</script>
<style lang="less">
.my-logEnterprise-wrapper {
    height:100vh;
    padding: 10px;
    overflow: auto;
    background-color: #ffffff;
    box-sizing: border-box;
    .hua-image {
        border-radius: 0 !important;
    }
    .hua-swipe__indicators {
        bottom: 15px;
    }
    .top-block {
        height: 180px;
        .hua-swipe {
            height: 100%;
        }
    }
    .ad-box {
        position: relative;
        margin-top: 10px;
        width: 100%;
        height: 200px;
        .ad-img {
            width: 100%;
            height: 100%;
        }
        .btn {
            position: absolute;
            width: 145px;
            height: 60px;
        }
        .btn-box1 {
            top: 48px;
            right: 13px;
        }
        .btn-box2 {
            top: 120px;
            right: 13px;
        }
    }
    .apply-img {
        margin-top: 10px;
        width: 100%;
        height: 165px;
    }
    .approve-box {
        position: relative;
        margin-top: 10px;
        height: 185px;
        .num-box {
            position: absolute;
            top: 60px;
            width: 25%;
            height: 30px;
            line-height: 30px;
            font-weight: 700;
            font-size: 18px;
            text-align: center;
        }
        .num1 {
            left: 20px;
        }
        .num2 {
            left: 50%;
            transform: translateX(-50%);
        }
        .num3 {
            right: 20px;
        }
        img {
            width: 100%;
            height: 100%;
        }
    }
    .hua-button--block {
        display: block;
        width: 80%;
        height: 0.5rem;
        // margin: 40% 10% 40% 10%;
    }
}
</style>
